import {
  Code,
  HStack,
  Icon,
  ListItem,
  OrderedList,
  Text,
  VStack,
} from '@chakra-ui/react';
import { AiOutlineBulb } from 'react-icons/ai/index.js';

export const Instructions = () => {
  return (
    <HStack alignItems='center' gap={6} bg='gray.100' p={4}>
      <Icon as={AiOutlineBulb} fontSize='xl' color='primary' />
      <VStack as={OrderedList} alignItems='start'>
        <ListItem>
          Make sure all options are selected before building the output layout.
        </ListItem>
        <ListItem>
          Hold down
          <Code bg='white' mx={2}>
            Ctrl
          </Code>
          (Windows) or
          <Code bg='white' mx={2}>
            Cmd
          </Code>
          (Mac) and click to select multiple rows. Hold down
          <Code bg='white' mx={2}>
            Shift
          </Code>
          to select a range of rows.
        </ListItem>
        <ListItem>
          Rows with field type
          <Text as='span' fontWeight='bold' mx={2}>
            Required
          </Text>
          cannot be deleted.
        </ListItem>
        <ListItem>
          There are shortcuts available for Undo (Ctrl + Z) , Redo (Ctrl + Y),
          Cut (Ctrl + X), Paste above (Ctrl + V + ⬆) and Paste below (Ctrl + V +
          ⬇).
        </ListItem>
      </VStack>
    </HStack>
  );
};
